// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout--with-icon[data-v-240cea3f]{display:grid;grid-template-columns:24px 1fr;align-items:center;column-gap:8px}.icon[data-v-240cea3f]{display:flex;align-items:center;justify-content:center}", ""]);
// Exports
module.exports = exports;
